<template>
    <div>
        <p class="label">Sources</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>

</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import SourceService from '@/services/source.service.js';

  export default {
    name: "SourcePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        SourceService.getListByStudent().then(({data}) => {
          _this.items = data;
        });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
